module.exports = __webpack_public_path__ + "assets/clock-listview-icon.2ada063f.svg";